export interface FlatInsuranceFields {
  sub_category_id: number | null;
  expiry_date: string | null;
  value: number | null;
  insurer_name: string | null;
  insured_name: string | null;
  policy_number: string | null;
}

const INSURANCE_FIELD_KEYS: (keyof FlatInsuranceFields)[] = [
  "sub_category_id",
  "expiry_date",
  "value",
  "insurer_name",
  "insured_name",
  "policy_number",
];

const fromApi = (extraInfo: Record<string, unknown>): FlatInsuranceFields => {
  const insurance = (
    extraInfo?.insurance && typeof extraInfo.insurance === "object"
      ? extraInfo.insurance
      : {}
  ) as Record<string, unknown>;

  return {
    sub_category_id:
      insurance.sub_category_id != null
        ? Number(insurance.sub_category_id)
        : null,
    expiry_date:
      typeof insurance.expiry_date === "string" ? insurance.expiry_date : null,
    value: insurance.value != null ? Number(insurance.value) : null,
    insurer_name:
      typeof insurance.insurer_name === "string" ? insurance.insurer_name : null,
    insured_name:
      typeof insurance.insured_name === "string" ? insurance.insured_name : null,
    policy_number:
      typeof insurance.policy_number === "string" ? insurance.policy_number : null,
  };
};

const toApi = (flat: FlatInsuranceFields): Record<string, unknown> => {
  const insurance: Record<string, unknown> = {};
  for (const key of INSURANCE_FIELD_KEYS) {
    if (flat[key] !== null && flat[key] !== undefined) {
      insurance[key] = flat[key];
    }
  }
  return { insurance };
};

export const InsuranceExtraInfo = { fromApi, toApi };
